import { ui } from "@patient-watch/ui";
import { formComponents as fc } from "@/features/i18n/formComponents";
import { createFileRoute } from "@tanstack/react-router";

const Diabetes = () => {
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

    return (
        <>
            <form className="px-2" onSubmit={handleSubmit}>
                <ui.Card title="Medical Details">
                    <ui.CardContent className="py-2">
                        <ui.Input></ui.Input>
                    </ui.CardContent>
                </ui.Card>
                <fc.NextButton />
            </form>
        </>
    );
};

export const Route = createFileRoute("/_app/profile/medical/diabetes")({
    component: Diabetes,
});
